/**
 * Update the core functions table with calculated averages
 * Updates both the table rows and the overall maturity rating in the footer
 * 
 * @param {string} tableId - The ID of the core functions table (e.g., 'nist2-core-functions')
 * @param {Object} coreFunctionAverages - Object containing core function averages keyed by code (e.g., 'GV', 'ID')
 * @param {Function} formatScore - Function to format scores to 2 decimal places
 */
function updateCoreFunctionsTable(tableId, coreFunctionAverages, formatScore) {
	// Update the core functions table with calculated averages
	const coreFunctionsTable = document.querySelector(`#${tableId} tbody`);
	if (coreFunctionsTable) {
		const coreFunctionMapping = {
			'GV': 'Govern (GV)',
			'ID': 'Identify (ID)', 
			'PR': 'Protect (PR)',
			'DE': 'Detect (DE)',
			'RS': 'Respond (RS)',
			'RC': 'Recover (RC)'
		};
		
		Array.from(coreFunctionsTable.rows).forEach(row => {
			const coreFunctionText = row.cells[0].textContent.trim();
			const coreFunctionMatch = coreFunctionText.match(/\(([A-Z]{2})\)/);
			
			if (coreFunctionMatch) {
				const coreFunctionCode = coreFunctionMatch[1];
				if (coreFunctionAverages[coreFunctionCode] !== undefined) {
					row.cells[1].textContent = formatScore(coreFunctionAverages[coreFunctionCode]);
					console.log(`Updated core function ${coreFunctionCode} with score:`, formatScore(coreFunctionAverages[coreFunctionCode]));
				} else {
					row.cells[1].textContent = "0.00";
					console.warn(`No data for core function ${coreFunctionCode}`);
				}
			}
		});
	}

	// Update the overall maturity rating in the tfoot section
	const coreFunctionsTfoot = document.querySelector(`#${tableId} tfoot`);
	if (coreFunctionsTfoot) {
		const overallRow = coreFunctionsTfoot.querySelector('tr');
		if (overallRow) {
			const overallValueSpan = overallRow.querySelector('.core-functions-overall-value');
			if (overallValueSpan) {
				// Calculate overall maturity rating from core function averages
				const coreFunctionValues = Object.values(coreFunctionAverages);
				if (coreFunctionValues.length > 0) {
					const overallCoreFunctionMaturity = coreFunctionValues.reduce((sum, value) => sum + value, 0) / coreFunctionValues.length;
					overallValueSpan.textContent = formatScore(overallCoreFunctionMaturity);
					console.log(`Updated overall core function maturity rating:`, formatScore(overallCoreFunctionMaturity));
				} else {
					overallValueSpan.textContent = "0.00";
				}
			}
		}
	}
}

